// extracted by mini-css-extract-plugin
module.exports = {"Toast_sucess":"Toast_Toast_sucess__10i3H","Toast_warning":"Toast_Toast_warning__1_jtd","Toast_error":"Toast_Toast_error__28s3u"};